import { MouseEvent, ReactElement, useState } from 'react';
import { PoolIconButton } from '@synergy/components-next';
import { alpha, styled } from '@mui/material';

import { FavoriteButtonProps } from './favorite-button';
import { FavoriteHeartIcon } from './components/favorite-heart-icon';
import { FavoriteToolTip } from './components/favorite-tool-tip';

const StyledIconButton = styled(PoolIconButton)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.8),
    },
}));

export const FavoriteIconButton = (props: FavoriteButtonProps): ReactElement => {
    const [isFavorite, setIsFavorite] = useState(props.isFavorite ?? false);

    const handleClick = (e: MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();
        if (!isFavorite) {
            setIsFavorite(true);
            props.onClick?.(e);
        }
    };
    return (
        <FavoriteToolTip>
            <StyledIconButton onClick={handleClick} size="large" color="medium">
                <FavoriteHeartIcon isFavorite={isFavorite} fontSize="medium" />
            </StyledIconButton>
        </FavoriteToolTip>
    );
};
